export default __webpack_public_path__ + "static/media/bike-4.a0ff6879.svg";